<template>
  <div
    style="display: flex; width: 100%;"
  >
    <v-tabs
      :value="current_tab"
      @change="change_tab"
      active-class="primary"
      vertical
      style="width: fit-content;"
    >
      <v-tab
        v-for="[id, value] in valid_model_tabs"
        :key="id"
        class="qmkey-explorer-table-expansion-panel-header"
      >
        <div :class="['tab ml-4 mr-4',readonly ? '' : 'ml-6 mr-6']">
          {{ id }}
        </div>
        <!-- Hide delete button -->
        <!-- It needs to think about it, who will able to delete it and how -->
        <v-btn
          v-if="!readonly && false"
          small
          icon
          fab
          @click="delete_tab(id)"
          style="position: absolute; right: 0px"
        >
          <v-icon v-if="!readonly"> {{ 'mdi-close' }}</v-icon>
        </v-btn>
      </v-tab>
      <AddValue
        v-if="!readonly"
        dict_value
        @submit="update_tab"
      />
    </v-tabs>
    <v-tabs-items
      :value="current_tab"
      style="width: 100%;"
    >
      <v-tab-item
        v-for="[id, value] in valid_model_tabs"
        :key="id"
      >
        <BPView
          :bp="json"
          :model="{[id]: value}"
          :readonly="readonly"
          @update="(val) => update(id,val)"
          :lang="lang"
          :is_mobile="is_mobile"
          :roles="roles"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  import BPView from '@/components/bpcreator/views/BPView';
  import AddValue from '@/components/bpcreator/model/AddValue';
  import BP from '@/qunit/BP';
  export default {
    components: {
      BPView,
      AddValue,
    },
    
    name: 'JsonViewer',
    
    props: {
      json: {default: () => (new BP({}))},
      readonly: Boolean,
      lang: String,
      is_mobile: Boolean,
      roles: {default: ()=>({admin:false,manager:false,user:false})},
    },
    
    data: () => ({
      current_tab: 0,
      user_valid_tabs: {
        'isAdmin': [], // Will take all bp
        'isManager': ['model','roles','states','filters','columns','transitions','inline_boxes'],
        'user': ['nothing'],// The BPs doesn't have the property nothing
      },
    }),
    
    computed: {
      valid_model_tabs() {
        return Object.entries(this.json.raw).filter(it => this.valid_tabs().includes(it[0]))
      }
    },
    
    mounted() {
    },
    
    methods: {
      change_tab(tab) {
        this.current_tab = tab;
      },

      update(id,value) {
        this.$emit('update',this.json.update(id,value));
      },

      update_tab(data) {
        this.update(data.name,data.default_value);
        this.current_tab = Object.keys(this.json).length;
      },

      delete_tab(tab) {
        let new_json = {...this.json};
        delete new_json[tab];
        this.$emit('update',new_json);
        
      },

      valid_tabs() {
        let res = [];
        if (this.roles['isAdmin']) {
          res = Object.keys(this.json.raw);
        } else if (this.roles['isManager']) {
          res = this.user_valid_tabs['isManager']; 
        }
        return res;
      },
    },

    watch: {
    },
  }

</script>